import axios from "axios";
import React, { useContext, useState } from "react";
import { axiosConfig, useEffectOnce } from "../../../utils/Utils";
import { AppContext } from "../../Store";
import Endpoint from "./../../../endpoints/Endpoint";
import CtSponzorDto from "./CtSponzorDto";
import DisplaySponzor from "./DisplaySponzor";

export default function DisplaySponsorList() {
  const { authData } = useContext(AppContext);
  const [sponzorOrganizationList, setSponzorOrganizationList] = useState([]);

  useEffectOnce(() => {
    const requestSponsorOrganizationList = axios.get(Endpoint.SPONZOR, axiosConfig(authData?.token, {}));

    axios
      .all([requestSponsorOrganizationList])
      .then(
        axios.spread((responseSponsorOrganizationList: any) => {
          setSponzorOrganizationList(responseSponsorOrganizationList.data.data);
        })
      )
      .catch((e) => {
        console.log(e);
      });
  });

  return (
    <div className="layout-sponsor">
      <div className="panel-sponsor">
        <div className="flex justify-center">
          {sponzorOrganizationList.map((sponzor: CtSponzorDto) => {
            return (
              <div key={sponzor.id} className="flex-1">
                <DisplaySponzor key={sponzor.id} sponzor={sponzor} />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
